import { getExportResponseSchema, createExportResponseSchema, updateExportResponseSchema, excelExportResponseSchema, } from '@consigli/types';
import { createTransformer, mapToSnakeCase } from './shared/base-api';
export const exportApiEndpoints = (builder, coreApiBaseUrl) => ({
    getExportByPackageId: builder.query({
        query: ({ projectId, packageId }) => `${coreApiBaseUrl}/projects/${projectId}/packages/${packageId}/exports/`,
        providesTags: ['Exports'],
        transformResponse: createTransformer(getExportResponseSchema, 'GetExportByPackageId'),
    }),
    createExport: builder.mutation({
        query: ({ projectId, packageId, exports }) => ({
            url: `${coreApiBaseUrl}/projects/${projectId}/packages/${packageId}/exports/`,
            method: 'POST',
            body: {
                ...exports,
                document_package_id: packageId,
            },
        }),
        invalidatesTags: ['Exports'],
        transformResponse: createTransformer(createExportResponseSchema, 'CreateExportResponse'),
    }),
    updateExport: builder.mutation({
        query: ({ projectId, packageId, data, exportId }) => ({
            url: `${coreApiBaseUrl}/projects/${projectId}/packages/${packageId}/exports/${exportId}`,
            method: 'PATCH',
            body: data,
        }),
        invalidatesTags: ['Exports'],
        transformResponse: createTransformer(updateExportResponseSchema, 'UpdateExport'),
    }),
    exportToExcel: builder.mutation({
        query: ({ projectId, packageId, excelExport }) => {
            return {
                url: `${coreApiBaseUrl}/projects/${projectId}/packages/${packageId}/export-excel/`,
                method: 'POST',
                body: mapToSnakeCase(excelExport),
            };
        },
        transformResponse: createTransformer(excelExportResponseSchema, 'ExportToExcel'),
    }),
});
